<template>

<section class="reviews pt-5 pb-5">
    <div class="container mb-4">
        <div class="row mb-4">
            <div class="col-12">
                <h2 class="text-center">
                    <span class="stars d-block">
                        <span class="material-icons-round">&#xe8d0;</span>
                        <span class="material-icons-round">&#xe8d0;</span>
                        <span class="material-icons-round">&#xe8d0;</span>
                    </span>
                    Recent Reviews
                </h2>
            </div>
        </div>

        <div class="row d-flex justify-content-center">
            <!-- Plan Start -->
            <div v-for="i in 6" class="col-12 col-md-6 col-xl-4 mb-4">                   
                
                <div class="white-box review-box">
                    
                    <div class="row d-flex align-items-center justify-content-center">
                        <div class="col-5 p-0 text-right">
                            <img src="/resources/images/men.jpg" alt="Reviewer photo" class="reviewer-photo" />
                        </div>
                        <div class="col-2 p-0 text-center">
                            <span class="material-icons-round">&#xe5cc;</span>
                        </div>
                        <div class="col-5 p-0">
                            <img src="/resources/images/model.jpg" alt="Model photo" class="reviewer-photo" />
                        </div>
                    </div>

                    <div class="row d-flex align-items-center justify-content-center">
                        <div class="col-5 p-0 text-right">
                            <strong class="mr-2 d-block">Jason Doe</strong> 
                        </div>
                        <div class="col-2 p-0 text-center">
                            <small class="d-block">reviewed</small> 
                        </div>
                        <div class="col-5 p-0">
                            <strong class="ml-2 d-block">Anna Bockova</strong>
                        </div>
                    </div>

                    <div class="d-flex align-items-center justify-content-center">
                        <span>9.1</span>
                    </div>

                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam ut dolor tristique dui aliquet tristique. 
                        Morbi elit est, feugiat a vestibulum et, egestas sit amet diam. 
                        Fusce ullamcorper finibus odio, vel dapibus nisl luctus eu. Duis eleifend dictum luctus.”
                    </p>

                    <a href="#" class="d-flex align-items-center justify-content-center">
                        See the reviewd profile 
                        <span class="material-icons-round small-icon">east</span>
                    </a>

                </div>

            </div>
            <!-- Plan End -->
        </div>  

        <div class="row d-flex justify-content-center">
            <div class="col-12 text-center">
                <a href="#" class="btn btn-outline-primary">See more</a>
            </div> 
        </div> 
    </div>
</section>


</template>

<script>
    export default {

        mounted() {

        },

        created() {
           
        },

        data() {
            return {
                isReady : false,
            }
        },

        methods : {

        }

    }
</script>
